import React from 'react';

const NotFound = () => <div>Whoooooopsss...... nothing found here!!</div>

export default NotFound;